import {EffectCallback, useEffect, useRef} from 'react';

/** Can be used to prevent a useEffect from triggering upon the first render */
export const useNonMountEffect = (
  func: EffectCallback,
  dependencies: unknown[]
): void => {
  const didMount = useRef(false);

  useEffect(() => {
    if (didMount.current) {
      return func();
    } else {
      didMount.current = true;
    }
    // dependencies are passed from outside
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, dependencies);
};

/** Use effect that only triggers on mount */
export const useMountEffect = (func: EffectCallback): void => {
  // only run the function on mount
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(func, []);
};
